const TOKEN_KEY = 'strongova_admin_token'
const ADMIN_KEY = 'strongova_admin_profile'

export function getToken () {
  return window.localStorage.getItem(TOKEN_KEY) || ''
}

export function setSession (token, admin) {
  window.localStorage.setItem(TOKEN_KEY, token)
  window.localStorage.setItem(ADMIN_KEY, JSON.stringify(admin || {}))
}

export function clearSession () {
  window.localStorage.removeItem(TOKEN_KEY)
  window.localStorage.removeItem(ADMIN_KEY)
}

export function getAdminProfile () {
  try {
    return JSON.parse(window.localStorage.getItem(ADMIN_KEY) || '{}')
  } catch (error) {
    return {}
  }
}
